"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagMO = function FlagMO(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#5aa587"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.7,48.67a52.22,52.22,0,0,0,24.82-.06A52.61,52.61,0,0,0,87,22.74a52.2,52.2,0,0,0-62.67,3.57l.16-.22C46.45,6.31,70.93,12.7,70.93,12.7l5.79-4.95S52-.78,29.91,17.51C43.6-9,28.83-31.72,28.83-31.72l-3.4,6.81S37.71-2.38,23.34,23.9a.15.15,0,0,0-.05.06A52.17,52.17,0,0,0,28.83.64a52.6,52.6,0,0,0-17-38.76A52.6,52.6,0,0,0-5.23.64,52.17,52.17,0,0,0,.31,24s0-.05,0-.06C-14.11-2.38-1.83-24.91-1.83-24.91l-3.4-6.81S-20-9-6.32,17.51C-28.43-.78-53.12,7.75-53.12,7.75l5.79,4.95S-22.85,6.31-.93,26.09a1.77,1.77,0,0,1,.16.22A52.07,52.07,0,0,0-21.72,15.55a52.54,52.54,0,0,0-41.71,7.19A52.61,52.61,0,0,0-29.92,48.61a52.22,52.22,0,0,0,24.82.06c-29.5,8.24-48.8-9.53-48.8-9.53l-7.43,1.67s29.82,32,73.13.61c43.31,31.36,73.13-.61,73.13-.61l-7.44-1.67S58.2,56.91,28.7,48.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-31.25,85.47a82.74,82.74,0,0,0,9.63,5.11H45.21a81.15,81.15,0,0,0,9.63-5.11Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-15.63,93A81.44,81.44,0,0,0,11.8,97.72,81.44,81.44,0,0,0,39.23,93Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-49.37,70.19c1,1.16,2.09,2.3,3.19,3.4h116c1.09-1.1,2.14-2.24,3.17-3.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-41.89,77.59c1.71,1.49,3.46,2.91,5.29,4.26H60.19q2.75-2,5.3-4.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M45.86,61.11c-19.08,0-32.13-12.75-32.26-12.89l-1.81-1.79L10,48.23c-.13.13-13.1,12.88-32.26,12.88H-56.36c1.16,1.75,2.4,3.45,3.7,5.1h30.4c17.14,0,29.58-9,34.06-12.74,4.48,3.78,16.93,12.74,34.06,12.74H76.27c1.29-1.65,2.53-3.35,3.69-5.1Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.91-72.72l-3,9-9.45.07A.94.94,0,0,0-2.08-62l7.6,5.61-2.85,9a.94.94,0,0,0,1.45,1L11.8-51.8l7.69,5.49a.94.94,0,0,0,1.45-1l-2.85-9L25.69-62a.94.94,0,0,0-.55-1.7l-9.45-.07-3-9a.94.94,0,0,0-1.79,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-33.81-54.37l1.74,6.28-5.39,3.67a.65.65,0,0,0,.34,1.19l6.51.3,1.82,6.25a.66.66,0,0,0,1.24,0l2.29-6.11,6.52.2a.65.65,0,0,0,.42-1.16l-5.09-4.06,2.2-6.14a.65.65,0,0,0-1-.76l-5.44,3.59-5.16-4a.65.65,0,0,0-1,.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-59.87-22.72l4.71,4.5-2.74,5.91a.65.65,0,0,0,.9.85l5.74-3.09,4.78,4.43a.65.65,0,0,0,1.08-.6l-1.16-6.41,5.69-3.18a.65.65,0,0,0-.23-1.21l-6.46-.87-1.26-6.4A.66.66,0,0,0-50-28.94l-2.83,5.87-6.46-.77a.65.65,0,0,0-.53,1.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M58.89-54.37l-1.73,6.28,5.38,3.67a.65.65,0,0,1-.34,1.19l-6.51.3-1.82,6.25a.66.66,0,0,1-1.24,0l-2.29-6.11-6.52.2a.65.65,0,0,1-.42-1.16l5.09-4.06-2.2-6.14a.65.65,0,0,1,1-.76l5.44,3.59,5.16-4a.65.65,0,0,1,1,.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M85-22.72l-4.71,4.5L83-12.31a.65.65,0,0,1-.9.85l-5.74-3.09-4.78,4.43a.65.65,0,0,1-1.08-.6l1.16-6.41L66-20.31a.65.65,0,0,1,.23-1.21l6.46-.87,1.27-6.4a.65.65,0,0,1,1.22-.15L78-23.07l6.47-.77A.65.65,0,0,1,85-22.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagMO;
exports["default"] = _default;